module.exports = __webpack_public_path__ + "static/05-56121c8954846e2185bd84039cb2b121.jpg";